import React from 'react';
import {
  ForgeAppBar,
  ForgeButton,
  ForgeIcon,
  ForgeScaffold,
} from '@tylertech/forge-react';
import { useNavigate, useLocation } from 'react-router';
import ImageContainer from '../../reusable/ImageContainer.js';
import ForgeStack from '../../reusable/ForgeStack/ForgeStack.js';
import { SIGN_IN, SIGN_OUT_OF_SSO } from '../../../static/keyWords.js';
import './SessionTimeout.scss';
import { SESSION_TIMEOUT, MANUAL_LOGOUT } from '../../../static/constants.js';
import { messageManager } from '../messageManager/messageManager.js';
import { NAVIGATION_PATHS } from '../../../static/navigationPaths.js';
import { useNameConventions } from '../../../contexts/nameConventionsContext.js';
import {
  canAttemptSilentAuthentication,
  startSilentAuthentication,
} from '../../../services/ssoService.js';

const SessionTimeout = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { nameConventions } = useNameConventions();

  const handleSignIn = () => {
    if (canAttemptSilentAuthentication()) {
      startSilentAuthentication('/');
      return;
    }

    navigate(NAVIGATION_PATHS.LOGIN);
  };

  return (
    <>
      <ForgeScaffold>
        <ForgeAppBar
          title-text="Priority Based Budgeting"
          theme-mode="scoped"
          slot="header"
        >
          <ForgeIcon slot="logo" name="tyler_talking_t_logo" />
        </ForgeAppBar>
        <ForgeStack slot="body" justify="center" alignment="center">
          <ImageContainer
            slot="graphic"
            source={state?.manualLogout ? MANUAL_LOGOUT.source : SESSION_TIMEOUT.source}
            alt={state?.manualLogout ? MANUAL_LOGOUT.alt : SESSION_TIMEOUT.alt}
            customClasses={'session-timeout-graphic'}
          />
          <div className="forge-typography--heading5 opacity54">
            {state?.manualLogout ? messageManager(nameConventions).MANUAL_LOGOUT.TITLE : messageManager(nameConventions).SESSION_TIMEOUT.TITLE}
          </div>
          <p className="forge-typography--body2">
            {state?.manualLogout ? messageManager(nameConventions).MANUAL_LOGOUT.MESSAGE : messageManager(nameConventions).SESSION_TIMEOUT.MESSAGE}
          </p>
          <div className="flexContainer withGap">
            <ForgeButton
              variant="raised"
              slot="action"
              onClick={handleSignIn}
            >
              {SIGN_IN}
            </ForgeButton>
            <ForgeButton
              variant="outlined"
              slot="action"
              onClick={() => state?.gatewayLogin ?
                window.location.href = process.env.REACT_APP_END_GATEWAY_SSO_SESSION_URL :
                window.location.href = process.env.REACT_APP_END_SSO_SESSION_URL}
            >
              {SIGN_OUT_OF_SSO}
            </ForgeButton>
          </div>
        </ForgeStack>
      </ForgeScaffold>
    </>
  );
};

export default SessionTimeout;
